export const employeeKeys = {
  all:           ()               => ['employees']                           as const,
  byAccessRole:  (roleId: number) => ['employees', 'list', roleId]           as const,
  byEntity:      (entityId: number) => ['employees', 'detail', entityId]    as const,
};
